import { render } from "./Merci.vue?vue&type=template&id=1d6647be"
import script from "./Merci.vue?vue&type=script&lang=js"
export * from "./Merci.vue?vue&type=script&lang=js"

import "./Merci.vue?vue&type=style&index=0&id=1d6647be&lang=css"

import exportComponent from "/Users/davidmarchesson2/Sites/app.idtonic.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__